export const WALLET_LINKING = 'wallet-linking';

export const ACSC_SYSTEM = 'acsc';
export const EVERI_SYSTEM = 'everi';

export const SYSTEM_TO_PLAYER_TAG_MAP = {
    [ACSC_SYSTEM]: 'uam/aristocrat/ACSCWalletId',
    [EVERI_SYSTEM]: 'uam/aristocrat/EveriWalletId'
};

export const RETAIL_CARD_NUMBER_TAG = 'uam/aristocrat/RetailCardNumber';
export const DOCUMENT_DATA_TAG = 'uam/personalData/documentData';
